<template>
	<div class="toolbar-filter-bar" :class="{ 'toolbar-filter-bar--embed': embed }">
		<el-form
			:inline="true"
			:model="model"
			:size="size"
			class="toolbar-filter-form"
			@submit.native.prevent="$emit('submit')">
			<div class="toolbar-filter-fields">
				<slot name="fields"></slot>
				<el-form-item v-if="showQuery">
					<el-button
						type="primary"
						:size="size"
						icon="el-icon-search"
						:loading="queryLoading"
						@click="$emit('query')">{{ queryText }}</el-button>
				</el-form-item>
			</div>
			<div v-if="$slots.actions" class="toolbar-filter-actions">
				<slot name="actions"></slot>
			</div>
		</el-form>
		<slot></slot>
	</div>
</template>

<script>
/**
 * 自定义筛选条容器，与全站 toolbar-filter-bar 样式一致。创建于 2026-08-28
 */
export default {
	name: 'ToolbarFilterBar',
	props: {
		model: {
			type: Object,
			default: null,
		},
		size: {
			type: String,
			default: 'medium',
		},
		embed: {
			type: Boolean,
			default: false,
		},
		showQuery: {
			type: Boolean,
			default: false,
		},
		queryText: {
			type: String,
			default: '查询',
		},
		queryLoading: {
			type: Boolean,
			default: false,
		},
	},
}
</script>
